export default __webpack_public_path__ + "static/media/pariuri-logo.26b412a2.png";